import React from 'react';
import "./Loader.scss";
export interface ILoaderProps { };

const Loader: React.FunctionComponent<ILoaderProps> = (props) => {
  return <div className="Loader" data-testid="Loader">
    <img src='wizard/assets/images/Schneider_Spinner-transparent.gif' onError={({ currentTarget }) => {
      currentTarget.onerror = null;
      currentTarget.src = "./assets/images/Schneider_Spinner-transparent.gif";
    }} alt="Loading" className='loading_logo' data-testid="LoaderImage" />
  </div>
}
export default Loader;